module.exports = __webpack_public_path__ + "img/cat-01-ac.97e1cde8.svg";